import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const NoOneIsIllegal = () => {
  return (
    <>
      <Typography
        variant="h5"
        component="div"
        style={{marginTop: "15px", marginBottom: "10px"}}
      >
        NO ONE IS ILLEGAL
      </Typography>
      <Typography variant="body2">
        Punk Illegal supports The No One is Illegal Network (Ingen människa är illegal in Swedish) and profits from the
        festival goes the the network. No One is Illegal works to provide practical support to people who are forced to
        live undocumented after having had their applications for asylum refused. They demand permanent right of
        residence for all people who have arrived in Sweden and wish to remain. Furthermore, they believe in a world
        without borders, a world where no one is illegal. Please, help support their work!
      </Typography>
      <Typography
        variant="h5"
        style={{marginTop: "15px"}}
      >
        <Box
          component="span"
          fontWeight="bold"
        >
          <a
            href={"https://www.ingenillegal.org/english"}
            target="_blank"
            rel="noreferrer"
          >
            NO ONE IS ILLEGAL
          </a>{" "}
        </Box>
      </Typography>
    </>
  );
};

export default NoOneIsIllegal;
